import { render, staticRenderFns } from "./packageOrderRefound.vue?vue&type=template&id=c6c7823a&"
import script from "./packageOrderRefound.vue?vue&type=script&lang=js&"
export * from "./packageOrderRefound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports